import i18next from "i18next";
import XHR from "i18next-xhr-backend";
import { LoggerFactory } from "lego-gui-lib";
import { initReactI18next, useTranslation } from "react-i18next";
import { mainStore } from "../mainStore";

const log = LoggerFactory.create("LanguageSelector");

export const i18nReady = i18next
  .use(XHR)
  .use(initReactI18next)
  .init({
    lng: window.localStorage.getItem("language") || "en",
    fallbackLng: "en",
    debug: true,
    keySeparator: ":",
    defaultNS: "common",
    ns: ["common", "hns", "lego"],
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
    }
  });

type Language = {
  languageCode: LanguageCode;
  languageName: string;
  languageTag: string;
};

export enum LanguageCode {
  Czech = "cs",
  English = "en"
}

export const languages: Language[] = [
  {
    languageCode: LanguageCode.English,
    languageName: "English",
    languageTag: "en-GB"
  },
  {
    languageCode: LanguageCode.Czech,
    languageName: "Čeština",
    languageTag: "cs-CZ"
  }
];

export const getLanguageTag = (languageCode: string) => {
  return (
    languages.find(value => value.languageCode === languageCode)?.languageTag ||
    "en-GB"
  );
};

export const changeTranslation = (langCode: string) => {
  i18next.changeLanguage(langCode);
  window.localStorage.setItem("language", langCode);
  mainStore.api.setAcceptLanguage(getLanguageTag(langCode));
  log.debug("lang changed to ", langCode);
};

// @ts-ignore
export const t = (...args: any[]) => () => i18next.t(...args);
export { i18next };
